var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    height: 40,
    viewBox: "0 0 40 40",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.9997 3.3335c-9.205 0-16.66669 7.4617-16.66669 16.6667 0 8.355 6.155 15.255 14.17499 16.46v-12.0434h-4.1233v-4.3816h4.1233v-2.915c0-4.8267 2.3517-6.945 6.3633-6.945 1.9217 0 2.9367.1416 3.4184.2066v3.8234h-2.7367c-1.7033 0-2.2983 1.615-2.2983 3.435v2.395h4.9916l-.6766 4.3816h-4.3134v12.0784c8.135-1.1017 14.41-8.0584 14.41-16.495 0-9.205-7.4616-16.6667-16.6666-16.6667z"
  })));
};
export default SvgFacebook;